import { render, staticRenderFns } from "./WordResult.vue?vue&type=template&id=664ec784&scoped=true&"
import script from "./WordResult.vue?vue&type=script&lang=js&"
export * from "./WordResult.vue?vue&type=script&lang=js&"
import style0 from "./WordResult.vue?vue&type=style&index=0&id=664ec784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ec784",
  null
  
)

export default component.exports